import "./helper.scss";
import m from "mithril";
import button from "./app/components/button/index";
import simpleSelect from "./components/simple-select/simple-select";
export default {
	Reset: () => {
		customObject = {};
	},
	get Data() {
		return customObject;
	},
	set Data(val) {
		customObject = val;
	},
	Button: (text, onclick, icon) => {
		return m(button, {label: text, iconleft: icon, onclick});
	},
	IconButton: (icon, onclick) => {
		return m(button, {icon, onclick});
	},
	GroupHorizontal: (children, gap) => {
		return m(
			".prasora-stack-tenet.horizontal",
			{
				oncreate: (u) => {
					if (gap) u.dom.style.setProperty("--prasora-stack-gap-tenet", gap);
				},
			},
			children
		);
	},
	GroupVertical: (children, gap) => {
		return m(
			".prasora-stack-tenet.vertical",
			{
				oncreate: (u) => {
					if (gap) u.dom.style.setProperty("--prasora-stack-gap-tenet", gap);
				},
			},
			children
		);
	},
	Tag: (labeltext) => {
		// console.log({labeltext});
		return m("span.prasora-tag-tenet", labeltext);
	},
	Label: (labeltext, content, labelwidth = "200px", options = {}, contentfunc) => {
		// console.log({ labeltext, content, labelwidth, options, contentfunc });
		return m(
			"label.prasora-label-tenet",
			{
				style: `display: grid; grid-template-columns: ${labelwidth} 1fr;`,
			},
			[m("span.caption", labeltext), m("span.value", contentfunc ? contentfunc() : content)]
		);
	},
	Input: (val, options = {}) => {
		return m("input.prasora-input-tenet", {value: val, ...options});
	},
	TextArea: (val, options = {}) => {
		return m("textarea.prasora-input-tenet", {value: val, ...options});
	},
	Checkbox: (val, options = {}) => {
		return m("input.prasora-input-tenet", {type: "checkbox", checked: val, ...options});
	},
	GetInteger(txt) {
		if (!txt || !txt) return "";

		var val = parseInt(txt, 10);

		if (isNaN(val)) return "";
		else return val;
	},
	SelectSimple: (val, list, onselect, nullable = true) => {
		// console.log({ list });
		return m(simpleSelect, {items: list, onselect, value: val, nullable});
	},
	SelectSimpleButton: (val, list) => {},
	SelectSimpleRadio: (val, list) => {},
};

let customObject = {};
